module.exports = __webpack_public_path__ + "fonts/AntikorMono-News.f4bbae8d.eot";